export default __webpack_public_path__ + "static/media/calendarRight.64bc4957.svg";